import { Component, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as feather from 'feather-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ChartConfiguration } from 'chart.js';
import { FlatpickrInstance } from 'ng2-flatpickr/src/flatpickr-instance';
import { Subscription, Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Client, Telephone, Address, Information, Email } from '../../../../../../models/client';
import { ClientService } from '../../../../../../services/Client/client.service';

@Component({
    selector: 'app-details-contenue-apercue',
    templateUrl: './details-contenue-apercue.component.html',
    styleUrls: ['./details-contenue-apercue.component.scss'],
})
export class DetailsContenueApercueComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('addressModal') addressModal: any;
    @ViewChild('deletePhoneModal') deletePhoneModal: any;
    @ViewChild('deleteAddressModal', { static: true }) deleteAddressModal: any;
    @ViewChild('deleteEmailModal', { static: true }) deleteEmailModal: any;
    @ViewChild('flatpickr', { static: false }) flatpickr: any;
    @ViewChild('dateLabel', { static: false }) dateLabel: ElementRef;
    @ViewChild('datePickerContainer', { static: false }) datePickerContainer: ElementRef;
    isPhoneEditMode = false;
    isEmailEditMode = false;
    client: Client = {
        type: '',
        civilite: '',
        nom_prenom: '',
        station_id: 0,
        user_id: 0,
        identifiant_unique: null,
        emails: [],
        is_archive: false,
        telephones: [],
        adresses: [],
        informations: [],
    };

    addr: Address = {
        type: 'facturation',
        adresse: '',
        pays: '',
        region: '',
        code_postal: '',
        station_id: 0,
        user_id: 0,
        client_id: 0,
    };
    phoneToEdit: any = { type: 'mobile', num_tel_full: '' };
    emailToEdit: any = { email: '' };
    addressToDelete: Address | null = null;
    phoneToDelete: Telephone = { type: 'mobile', num_tel: '', code_pays: '+212', station_id: 0, user_id: 0, client_id: 0 };
    emailToDelete: Email = { email: '', user_id: 0, client_id: 0, station_id: 0 };
    deletePhoneIndex: number | null = null;
    deleteAddressIndex: number | null = null;
    deleteEmailIndex: number | null = null;
    isStep3Valid: boolean = false;
    isEditMode: boolean = false;
    editIndex: number | null = null;
    private modalRef: NgbModalRef | null = null;
    private repositionInterval: any = null;
    isPhoneAddMode: boolean = false;
    isEmailAddMode: boolean = false;
    private subscriptions: Subscription[] = [];
    stationId: number = 0;
    userId: number = 0;
    isLoading: boolean = false;
    isAddMode: boolean = false;

    public DateRangeOptions = {
        altInput: false,
        mode: 'range',
        dateFormat: 'Y-m-d',
        defaultDate: ['2019-05-01', '2019-05-10'],
        enableTime: false,
        locale: {
            firstDayOfWeek: 1,
        },
        appendTo: undefined,
        onReady: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
            //console.log('Flatpickr onReady:', instance);
            this.positionCalendar(instance);
        },
        onOpen: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
            //console.log('Flatpickr opened:', instance);
            this.positionCalendar(instance);
            this.repositionInterval = setInterval(() => {
                this.positionCalendar(instance);
            }, 100);
        },
        onClose: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
           // console.log('Flatpickr closed:', dateStr);
            if (this.repositionInterval) {
                clearInterval(this.repositionInterval);
                this.repositionInterval = null;
            }
        },
    };

    public barChart: ChartConfiguration<'bar'> = {
        type: 'bar',
        data: {
            datasets: [
                {
                    data: [500, 300, 400, 200, 600, 450, 350],
                    backgroundColor: 'rgba(255, 159, 67, 1)',
                    borderColor: 'transparent',
                    hoverBackgroundColor: 'rgba(255, 159, 67, 1)',
                    hoverBorderColor: 'rgba(255, 159, 67, 1)',
                    borderRadius: 6,
                    borderSkipped: false,
                    barPercentage: 0.5,
                    categoryPercentage: 0.4,
                },
            ],
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        },
        options: {
            elements: {
                bar: {
                    borderWidth: 2,
                    borderSkipped: 'bottom',
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 500,
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    backgroundColor: '#ffffff',
                    titleColor: '#000000',
                    bodyColor: '#000000',
                    boxPadding: 4,
                },
            },
            scales: {
                x: {
                    display: true,
                    grid: {
                        display: true,
                        color: 'rgba(200, 200, 200, 0.2)',
                    },
                    ticks: {
                        color: '#6e6b7b',
                    },
                },
                y: {
                    display: true,
                    beginAtZero: true,
                    grid: {
                        color: 'rgba(200, 200, 200, 0.2)',
                    },
                    ticks: {
                        stepSize: 100,
                        maxTicksLimit: 7,
                        color: '#6e6b7b',
                    },
                },
            },
        },
    };

    constructor(
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal,
        private clientService: ClientService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        const clientId = this.route.parent?.snapshot.paramMap.get('reference');
        if (!clientId || clientId === 'add') {
            this.isAddMode = true;
            this.client = {
                type: 'Individuel',
                civilite: 'Homme',
                nom_prenom: '',
                station_id: this.stationId,
                user_id: this.userId,
                identifiant_unique: null,
                emails: [],
                is_archive: false,
                telephones: [{ type: 'mobile', num_tel: '', code_pays: '+212', station_id: this.stationId, user_id: this.userId, client_id: 0 }],
                adresses: [],
                informations: [],
            };
        } else {
            this.loadClientData(clientId);
        }
    }

    ngAfterViewInit(): void {
        feather.replace();
        this.refreshFeatherIcons();
        if (this.datePickerContainer && this.datePickerContainer.nativeElement) {
            this.DateRangeOptions.appendTo = this.datePickerContainer.nativeElement;
            this.cdr.detectChanges();
        } else {
            this.toasterInfo('Erreur : Conteneur du calendrier non trouvé.');
        }
    }

    ngOnDestroy(): void {
        if (this.repositionInterval) {
            clearInterval(this.repositionInterval);
            this.repositionInterval = null;
        }
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }

    @HostListener('window:scroll')
    @HostListener('window:resize')
    onScrollOrResize(): void {
        if (this.flatpickr && this.flatpickr.flatpickr && this.flatpickr.flatpickr.isOpen) {
            this.positionCalendar(this.flatpickr.flatpickr);
        }
    }

    private loadUserData(): void {
        try {
            const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
            this.stationId = user?.stations?.[0]?.id || 0;
            this.userId = user?.id || 0;
            if (!this.stationId) {
                this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                this.router.navigate(['/create-station']);
            }
            if (!this.userId) {
                this.toastr.error('Aucun utilisateur trouvé. Veuillez vous connecter.', 'Erreur');
                this.router.navigate(['/login']);
            }
        } catch (error) {
            this.toastr.error('Erreur lors de la récupération des données utilisateur.', 'Erreur');
            this.stationId = 0;
            this.userId = 0;
        }
    }

    private loadClientData(clientId: string): void {
        this.isLoading = true;
        const sub = this.clientService.getClientById(clientId).subscribe({
            next: (clientData) => {
                let emails: Email[] = [];
                if (clientData.emails) {
                    if (Array.isArray(clientData.emails) && typeof clientData.emails[0] === 'string') {
                        emails = clientData.emails.map(email => ({
                            email: email as string,
                            user_id: this.userId,
                            client_id: clientData.id || 0,
                            station_id: this.stationId,
                            id: undefined,
                            created_at: undefined,
                            updated_at: undefined
                        } as Email));
                    } else {
                        emails = (clientData.emails as Email[]).map(email => ({
                            id: email.id || undefined,
                            email: email.email || '',
                            user_id: this.userId,
                            client_id: clientData.id || 0,
                            station_id: this.stationId,
                            created_at: email.created_at || undefined,
                            updated_at: email.created_at || undefined
                        } as Email));
                    }
                }
                if (emails.length === 0) {
                    emails = [];
                }

                let adresses: Address[] = clientData.adresses?.map((addr) => ({
                    ...addr,
                    station_id: this.stationId,
                    user_id: this.userId,
                    client_id: clientData.id || 0
                })) || [];

                this.client = {
                    ...clientData,
                    emails,
                    telephones: clientData.telephones?.map((tel) => ({
                        ...tel,
                        num_tel: tel.num_tel || '',
                        code_pays: tel.code_pays || '+212',
                        station_id: this.stationId,
                        user_id: this.userId,
                        client_id: clientData.id || 0
                    })) || [],
                    adresses,
                    informations: clientData.informations?.map((info) => ({
                        ...info,
                        encours_atorise: info.encours_atorise || 0,
                        station_id: this.stationId,
                        user_id: this.userId,
                        client_id: clientData.id || 0
                    })) || [],
                };
                this.isLoading = false;
                //this.toastr.success('Données du client chargées', 'Succès');
                this.refreshFeatherIcons();
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.isLoading = false;
                const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors du chargement des données du client';
                this.toastr.error(errorMessage, 'Erreur');
                this.router.navigate(['/bibliotheque-clients/actif']);
            },
        });
        this.subscriptions.push(sub);
    }

    refreshFeatherIcons(): void {
        setTimeout(() => {
            feather.replace();
            this.cdr.detectChanges();
        }, 0);
    }

    toasterInfo(msg: string): void {
        this.toastr.info(msg, '', {
            positionClass: 'toast-bottom-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true,
        });
    }

    openFlatpickr(): void {
        if (this.flatpickr && this.flatpickr.flatpickr) {
            this.flatpickr.flatpickr.open();
        } else {
            this.toasterInfo('Erreur : Calendrier non initialisé.');
        }
    }

    positionCalendar(instance: FlatpickrInstance): void {
        if (this.dateLabel && this.dateLabel.nativeElement && instance.calendarContainer) {
            const labelRect = this.dateLabel.nativeElement.getBoundingClientRect();
            const container = instance.calendarContainer;
            const leftOffset = -10;
            const top = labelRect.bottom + window.scrollY + 5;
            const left = labelRect.left + window.scrollX + leftOffset;

            setTimeout(() => {
                container.style.position = 'absolute';
                container.style.top = `${top}px`;
                container.style.left = `${left}px`;
                container.style.zIndex = '10001';
                this.cdr.detectChanges();
            }, 0);
        } else {
            this.toasterInfo('Erreur : Positionnement du calendrier échoué.');
        }
    }

    onFlatpickrReady(event: [FlatpickrInstance, HTMLElement]): void {
        this.toasterInfo('Calendrier initialisé.');
    }

    onDateChange(selectedDates: Date[]): void {
        if (selectedDates.length === 2) {
            const [startDate, endDate] = selectedDates;
            this.toasterInfo(`Plage de dates sélectionnée : ${startDate.toLocaleDateString('fr-FR')} - ${endDate.toLocaleDateString('fr-FR')}`);
        }
    }

    addPhone(): void {
        if (this.client.telephones.length < 5) {
            this.client.telephones = [
                ...this.client.telephones,
                {
                    type: 'mobile',
                    num_tel: '',
                    code_pays: '+216',
                    station_id: this.stationId,
                    user_id: this.userId,
                    client_id: this.client.id || 0,
                }
            ];
            this.refreshFeatherIcons();
        } else {
            this.toasterInfo('Vous ne pouvez pas ajouter plus de 5 numéros de téléphone.');
        }
    }

    openDeletePhoneModal(index: number): void {
        if (this.client.telephones.length >= 1) {
            this.phoneToDelete = { ...this.client.telephones[index] };
            this.deletePhoneIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toasterInfo('Erreur lors de l’ouverture du modal de suppression de téléphone.');
            }
        } else {
            this.toasterInfo('Vous devez conserver au moins un numéro de téléphone.');
        }
    }

    confirmDeletePhone(): void {
        if (this.deletePhoneIndex !== null) {
            const updatedPhones = this.client.telephones.filter((_, i) => i !== this.deletePhoneIndex);
            this.client.telephones = updatedPhones;
            this.updateClient(updatedPhones, this.client.emails, this.client.adresses).subscribe({
                next: () => {
                    this.toasterInfo('Numéro de téléphone supprimé avec succès.');
                    this.closeDeletePhoneModal();
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression du numéro de téléphone.';
                    this.toasterInfo(errorMessage);
                    this.closeDeletePhoneModal();
                    this.client.telephones = [...this.client.telephones];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeletePhoneModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.phoneToDelete = null;
            this.deletePhoneIndex = null;
            this.refreshFeatherIcons();
        }
    }

    openDeleteAddressModal(index: number): void {
        if (this.client.adresses.length >= 1 && this.client.adresses[index]) {
            this.addressToDelete = { ...this.client.adresses[index] };
            this.deleteAddressIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deleteAddressModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toasterInfo('Erreur lors de l’ouverture du modal de suppression d’adresse.');
            }
        } else {
            this.toasterInfo('Vous devez conserver au moins une adresse.');
            this.toasterInfo('Ajoutez une autre adresse pour activer la suppression.');
        }
    }

    confirmDeleteAddress(): void {
        if (this.deleteAddressIndex !== null) {
            const updatedAddresses = this.client.adresses.filter((_, i) => i !== this.deleteAddressIndex);
            this.client.adresses = updatedAddresses;
            this.updateClient(this.client.telephones, this.client.emails, updatedAddresses).subscribe({
                next: () => {
                    this.toasterInfo('Adresse supprimée avec succès.');
                    this.closeDeleteAddressModal();
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression de l’adresse.';
                    this.toasterInfo(errorMessage);
                    this.closeDeleteAddressModal();
                    this.client.adresses = [...this.client.adresses];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeleteAddressModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.addressToDelete = null;
            this.deleteAddressIndex = null;
            this.refreshFeatherIcons();
        }
    }

    addEmail(): void {
        if (this.client.emails.length < 5) {
            this.client.emails = [...this.client.emails, {
                email: '',
                user_id: this.userId,
                client_id: this.client.id || 0,
                station_id: this.stationId
            } as Email];
            this.refreshFeatherIcons();
        } else {
            this.toasterInfo('Vous ne pouvez pas ajouter plus de 5 adresses e-mail.');
        }
    }

    openDeleteEmailModal(index: number): void {
        if (this.client.emails.length >= 1 && this.client.emails[index]) {
            this.emailToDelete = { ...this.client.emails[index] };
            this.deleteEmailIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toasterInfo('Erreur lors de l’ouverture du modal de suppression d’email.');
            }
        } else {
            this.toasterInfo('Vous devez conserver au moins une adresse e-mail.');
            this.toasterInfo('Ajoutez une autre adresse e-mail pour activer la suppression.');
        }
    }

    openPhoneModal(index: number | null, isAddMode: boolean, isEditMode: boolean = false): void {
        if (isAddMode && this.client.telephones.length >= 5) {
            this.toasterInfo('Maximum 5 numéros autorisés.');
            return;
        }
        if (!isAddMode && !isEditMode && this.client.telephones.length <= 1) {
            this.toasterInfo('Vous devez conserver au moins un numéro de téléphone.');
            return;
        }

        this.isPhoneAddMode = isAddMode;
        this.isEditMode = isEditMode; // true = édition, false = suppression

        if (isAddMode) {
            this.phoneToDelete = { type: 'mobile', num_tel: '', code_pays: '+216', station_id: this.stationId, user_id: this.userId, client_id: this.client.id || 0 };
        } else {
            this.phoneToDelete = { ...this.client.telephones[index!] };
            this.deletePhoneIndex = index;
        }

        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    openEmailModal(index: number | null, isAddMode: boolean, isEditMode: boolean = false): void {
        if (isAddMode && this.client.emails.length >= 5) {
            this.toasterInfo('Maximum 5 emails autorisés.');
            return;
        }
        if (!isAddMode && !isEditMode && this.client.emails.length <= 1) {
            this.toasterInfo('Vous devez conserver au moins une adresse e-mail.');
            return;
        }

        this.isEmailAddMode = isAddMode;
        this.isEditMode = isEditMode;

        if (isAddMode) {
            this.emailToDelete = { email: '', user_id: this.userId, client_id: this.client.id || 0, station_id: this.stationId };
        } else {
            this.emailToDelete = { ...this.client.emails[index!] };
            this.deleteEmailIndex = index;
        }

        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    confirmDeleteEmail(): void {
        if (this.deleteEmailIndex !== null) {
            const updatedEmails = this.client.emails.filter((_, i) => i !== this.deleteEmailIndex);
            this.client.emails = updatedEmails;
            this.updateClient(this.client.telephones, updatedEmails, this.client.adresses).subscribe({
                next: () => {
                    this.toasterInfo('Adresse e-mail supprimée avec succès.');
                    this.closeDeleteEmailModal();
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression de l’adresse e-mail.';
                    this.toasterInfo(errorMessage);
                    this.closeDeleteEmailModal();
                    this.client.emails = [...this.client.emails];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeleteEmailModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.emailToDelete = null;
            this.deleteEmailIndex = null;
            this.refreshFeatherIcons();
        }
    }

    deleteEmail(index: number): void {
        this.openEmailModal(index, false);
    }

    validateStep3(): void {
        this.isStep3Valid = !!this.addr.type && !!this.addr.pays && !!this.addr.region && !!this.addr.code_postal && !!this.addr.adresse;
    }

    openModal(): void {
        this.isEditMode = false;
        this.editIndex = null;
        this.addr = {
            type: 'facturation',
            adresse: '',
            pays: '',
            region: '',
            code_postal: '',
            station_id: this.stationId,
            user_id: this.userId,
            client_id: this.client.id || 0,
        };
        try {
            this.modalRef = this.modalService.open(this.addressModal, { centered: true, size: 'lg', ariaLabelledBy: 'modal-title' });
            this.validateStep3();
            this.refreshFeatherIcons();
        } catch (error) {
            this.toasterInfo('Erreur lors de l’ouverture du modal d’ajout d’adresse.');
        }
    }

    dismissModal(): void {
        if (this.modalRef) {
            this.modalRef.dismiss('Cancel click');
            this.modalRef = null;
            this.refreshFeatherIcons();
        }
    }

    saveAddress(): void {
        if (!this.isStep3Valid) {
            this.toasterInfo('Veuillez remplir tous les champs obligatoires.');
            return;
        }

        let updatedAddresses: Address[];
        if (this.isEditMode && this.editIndex !== null) {
            updatedAddresses = [...this.client.adresses];
            updatedAddresses[this.editIndex] = { ...this.addr };
        } else if (this.client.adresses.length < 5) {
            updatedAddresses = [...this.client.adresses, { ...this.addr }];
        } else {
            this.toasterInfo('Vous ne pouvez pas ajouter plus de 5 adresses.');
            return;
        }

        this.client.adresses = updatedAddresses;
        this.updateClient(this.client.telephones, this.client.emails, updatedAddresses).subscribe({
            next: (response) => {
                if (this.modalRef) {
                    try {
                        this.modalRef.close('Save click');
                        this.modalRef = null;
                    } catch (error) {
                        //console.error('saveAddress: Error closing modal=', error);
                    }
                }
                this.toasterInfo(this.isEditMode ? 'Adresse modifiée avec succès.' : 'Adresse ajoutée avec succès.');
                this.refreshFeatherIcons();
                this.cdr.detectChanges();
            },
            error: (error) => {
                const errorMessage = error?.message || error?.error?.message || 'Erreur inconnue lors de la mise à jour de l’adresse.';
                this.toasterInfo(errorMessage);
                if (this.isEditMode && this.editIndex !== null) {
                    this.client.adresses = [...this.client.adresses];
                } else {
                    this.client.adresses = this.client.adresses.slice(0, -1);
                }
                this.cdr.detectChanges();
            },
            complete: () => {
               // console.log('saveAddress: Observable completed');
            }
        });
    }

    editAddress(index: number): void {
        this.isEditMode = true;
        this.editIndex = index;
        this.addr = { ...this.client.adresses[index] };
        try {
            this.modalRef = this.modalService.open(this.addressModal, { centered: true, size: 'lg', ariaLabelledBy: 'modal-title' });
            this.validateStep3();
            this.refreshFeatherIcons();
        } catch (error) {
            this.toasterInfo('Erreur lors de l’ouverture du modal de modification d’adresse.');
        }
    }

    addClient(): Observable<Client> {
        const clientData: any = {
            type: this.client.type || 'Individuel',
            civilite: this.client.civilite || 'Homme',
            nom_prenom: this.client.nom_prenom || '',
            station_id: this.stationId,
            user_id: this.userId,
            identifiant_unique: this.client.identifiant_unique || null,
            emails: this.client.emails
                .filter(email => email.email)
                .map(email => email.email),
            is_archive: this.client.is_archive || false,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            telephones: this.client.telephones.map((phone) => ({
                type: phone.type === 'telephonePortable' ? 'mobile' : phone.type || 'mobile',
                num_tel: phone.num_tel.replace(phone.code_pays || '', '').trim() || '',
                code_pays: phone.code_pays || '+216',
                station_id: this.stationId,
                user_id: this.userId,
                client_id: 0,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            adresses: this.client.adresses.map((addr) => ({
                type: addr.type === 'facturation' ? 'adresse_fac' : addr.type === 'livraison' ? 'adresse_li' : addr.type,
                pays: addr.pays === 'France' ? 'FR' : addr.pays === 'Belgique' ? 'BE' : addr.pays === 'Suisse' ? 'CH' : addr.pays === 'Maroc' ? 'MA' : addr.pays,
                region: addr.region || null,
                code_postal: addr.code_postal,
                adresse: addr.adresse,
                station_id: this.stationId,
                user_id: this.userId,
                client_id: 0,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            information: this.client.informations.length ? {
                id: this.client.informations[0].id || undefined,
                encours_atorise: this.client.informations[0].encours_atorise || 0,
                prix_id: this.client.informations[0].prix_id || null,
                type_date: this.client.informations[0].type_date || null,
                nb_date: this.client.informations[0].nb_date || null,
                client_id: 0,
                station_id: this.stationId,
                user_id: this.userId,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            } : undefined,
        };

        //console.log('addClient: clientData=', JSON.stringify(clientData, null, 2));
        this.isLoading = true;
        return this.clientService.addClient(clientData).pipe(
            tap({
                next: (response) => {
                   // console.log('addClient: Client added=', JSON.stringify(response, null, 2));
                    this.client = {
                        ...response,
                        emails: Array.isArray(response.emails) ? response.emails.map((email: string | Email) => ({
                            email: typeof email === 'string' ? email : email.email || '',
                            user_id: this.userId,
                            client_id: response.id || 0,
                            station_id: this.stationId,
                            id: typeof email === 'string' ? undefined : email.id,
                            created_at: typeof email === 'string' ? undefined : email.created_at,
                            updated_at: typeof email === 'string' ? undefined : email.updated_at
                        } as Email)) : [],
                        telephones: Array.isArray(response.telephones) ? response.telephones.map((tel: any) => ({
                            ...tel,
                            num_tel: tel.num_tel || '',
                            code_pays: tel.code_pays || '+216',
                            station_id: this.stationId,
                            user_id: this.userId,
                            client_id: response.id || 0
                        })) : [],
                        adresses: Array.isArray(response.adresses) ? response.adresses.map((addr: any) => ({
                            ...addr,
                            station_id: this.stationId,
                            user_id: this.userId,
                            client_id: response.id || 0
                        })) : [],
                        informations: Array.isArray(response.informations) && response.informations.length ? [{
                            ...response.informations[0],
                            encours_atorise: response.informations[0].encours_atorise || response.informations[0].encours_atorise || 0,
                            station_id: this.stationId,
                            user_id: this.userId,
                            client_id: response.id || 0
                        }] : [],
                    };
                    //console.log('addClient: Updated emails=', JSON.stringify(this.client.emails, null, 2));
                    this.isAddMode = false;
                    this.isLoading = false;
                    this.toastr.success(`Client ${clientData.nom_prenom} ajouté`, 'Succès');
                    this.router.navigate(['/tiers/clients/details', response.identifiant_unique || response.id]);
                    this.refreshFeatherIcons();
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de l\'ajout du client';
                    //console.error('addClient: Add error=', JSON.stringify(error, null, 2));
                    this.toastr.error(errorMessage, 'Erreur');
                    this.cdr.detectChanges();
                    throw error;
                },
            })
        );
    }

    updateClient(telephones: Telephone[], emails: Email[], adresses: Address[]): Observable<Client> {
        if (!this.client.id && !this.isAddMode) {
            this.toastr.error('ID de client manquant pour la mise à jour.', 'Erreur');
            return throwError(() => new Error('Missing client ID'));
        }

        const clientData: any = {
            id: this.client.id || undefined,
            type: this.client.type || 'Individuel',
            civilite: this.client.civilite || 'Homme',
            nom_prenom: this.client.nom_prenom || '',
            station_id: this.stationId,
            user_id: this.userId,
            identifiant_unique: this.client.identifiant_unique || null,
            emails: emails
                .filter(email => email.email)
                .map(email => email.email),
            is_archive: this.client.is_archive || false,
            created_at: this.client.created_at || undefined,
            updated_at: new Date().toISOString(),
            telephones: telephones.map((phone) => ({
                id: phone.id || undefined,
                type: phone.type === 'telephonePortable' ? 'mobile' : phone.type || 'mobile',
                num_tel: phone.num_tel.replace(phone.code_pays || '', '').trim() || '',
                code_pays: phone.code_pays || '+216',
                station_id: this.stationId,
                user_id: this.userId,
                client_id: this.client.id || 0,
                created_at: phone.created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            adresses: adresses.map((addr) => ({
                id: addr.id || undefined,
                type: addr.type === 'facturation' ? 'adresse_fac' : addr.type === 'livraison' ? 'adresse_li' : addr.type,
                pays: addr.pays === 'France' ? 'FR' : addr.pays === 'Belgique' ? 'BE' : addr.pays === 'Suisse' ? 'CH' : addr.pays === 'Maroc' ? 'MA' : addr.pays,
                region: addr.region || null,
                code_postal: addr.code_postal,
                adresse: addr.adresse,
                station_id: this.stationId,
                user_id: this.userId,
                client_id: this.client.id || 0,
                created_at: addr.created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            information: this.client.informations.length ? {
                id: this.client.informations[0].id || undefined,
                encours_atorise: this.client.informations[0].encours_atorise || 0,
                prix_id: this.client.informations[0].prix_id || null,
                type_date: this.client.informations[0].type_date || null,
                nb_date: this.client.informations[0].nb_date || null,
                client_id: this.client.id || 0,
                station_id: this.stationId,
                user_id: this.userId,
                created_at: this.client.informations[0].created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            } : undefined,
        };

       // console.log('updateClient: clientData=', JSON.stringify(clientData, null, 2));
        this.isLoading = true;
        if (this.isAddMode) {
            return this.addClient();
        } else {
            return this.clientService.updateClient(this.client.id!, clientData).pipe(
                tap({
                    next: (response) => {
                        //console.log('updateClient: Client updated=', JSON.stringify(response, null, 2));
                        this.loadClientData(String(this.client.id!));
                        this.isLoading = false;
                       // this.toastr.success('Client mis à jour', 'Succès');
                        this.refreshFeatherIcons();
                        this.cdr.detectChanges();
                    },
                    error: (error) => {
                        this.isLoading = false;
                        const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour du client';
                        //console.error('updateClient: Update error=', JSON.stringify(error, null, 2));
                        this.toastr.error(errorMessage, 'Erreur');
                        this.cdr.detectChanges();
                        throw error;
                    },
                })
            );
        }
    }

    validateAndSavePhone(index: number): void {
        const phone = this.client.telephones[index];
        const phoneInput = phone.num_tel || '';
        const countryCodeMatch = phoneInput.match(/^(\+[0-9]{1,3})/);
        const code_pays = countryCodeMatch ? countryCodeMatch[1] : phone.code_pays || '+212';
        const num_tel = phoneInput.replace(code_pays, '').trim();

        if (num_tel && num_tel.match(/^[0-9]{8,}$/) && code_pays.match(/^\+[0-9]{1,3}$/)) {
            this.client.telephones[index] = {
                ...phone,
                code_pays,
                num_tel,
            };
            this.updateClient(this.client.telephones, this.client.emails, this.client.adresses).subscribe({
                next: () => {
                    this.toasterInfo('Numéro de téléphone mis à jour avec succès.');
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour du numéro de téléphone.';
                    this.toasterInfo(errorMessage);
                    this.client.telephones[index] = { ...phone };
                    this.refreshFeatherIcons();
                },
            });
        } else {
            this.toasterInfo('Veuillez entrer un numéro de téléphone valide (au moins 8 chiffres) et un code pays valide.');
        }
    }

    validateAndSaveEmail(index: number): void {
        const email = this.client.emails[index];
        if (email && email.email && email.email.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
            this.updateClient(this.client.telephones, this.client.emails, this.client.adresses).subscribe({
                next: () => {
                    this.toasterInfo('Adresse e-mail mise à jour avec succès.');
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour de l’adresse e-mail.';
                    this.toasterInfo(errorMessage);
                },
            });
        } else if (!email.email) {
            this.deleteEmail(index);
        } else {
            this.toasterInfo('Veuillez entrer une adresse e-mail valide.');
        }
    }

    // === Téléphone ===
    openPhoneAddModal() {
        this.isPhoneAddMode = true;
        this.isPhoneEditMode = false;
        this.phoneToEdit = { type: 'mobile', num_tel_full: '' };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    openPhoneEditModal(index: number) {
        this.isPhoneAddMode = false;
        this.isPhoneEditMode = true;
        const phone = this.client.telephones[index];
        this.phoneToEdit = {
            index,
            type: phone.type,
            num_tel_full: phone.code_pays + phone.num_tel
        };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    openPhoneDeleteModal(index: number) {
        this.isPhoneAddMode = false;
        this.isPhoneEditMode = false;
        this.phoneToEdit = { index, ...this.client.telephones[index] };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    confirmPhoneAction() {
        if (this.isPhoneAddMode || this.isPhoneEditMode) {
            const full = this.phoneToEdit.num_tel_full?.trim();
            if (!full || !/^\+[0-9]{1,3}[0-9]{8,}$/.test(full)) {
                this.toasterInfo('Numéro invalide. Ex: +21612345678');
                return;
            }
            const code_pays = full.match(/^\+[0-9]{1,3}/)![0];
            const num_tel = full.replace(code_pays, '');

            const newPhone = { type: this.phoneToEdit.type, code_pays, num_tel };

            if (this.isPhoneAddMode) {
                this.client.telephones.push(newPhone);
            } else {
                this.client.telephones[this.phoneToEdit.index] = newPhone;
            }
        } else {
            // Suppression
            this.client.telephones = this.client.telephones.filter((_, i) => i !== this.phoneToEdit.index);
        }

        this.updateClient(this.client.telephones, this.client.emails, this.client.adresses).subscribe({
            next: () => {
                //this.toasterInfo(this.isPhoneAddMode ? 'Ajouté' : this.isPhoneEditMode ? 'Modifié' : 'Supprimé');
                this.closePhoneModal();
            },
            error: () => this.closePhoneModal()
        });
    }

    closePhoneModal() {
        if (this.modalRef) this.modalRef.close();
        this.isPhoneAddMode = this.isPhoneEditMode = false;
        this.phoneToEdit = { type: 'mobile', num_tel_full: '' };
        this.refreshFeatherIcons();
    }

// === Email (même logique) ===
    openEmailAddModal() {
        this.isEmailAddMode = true;
        this.isEmailEditMode = false;
        this.emailToEdit = { email: '' };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    openEmailEditModal(index: number) {
        this.isEmailAddMode = false;
        this.isEmailEditMode = true;
        this.emailToEdit = { index, email: this.client.emails[index].email };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    openEmailDeleteModal(index: number) {
        this.isEmailAddMode = false;
        this.isEmailEditMode = false;
        this.emailToEdit = { index, email: this.client.emails[index].email };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
        this.refreshFeatherIcons();
    }

    confirmEmailAction() {
        const email = this.emailToEdit.email?.trim();
        if ((this.isEmailAddMode || this.isEmailEditMode) && !email?.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i)) {
            this.toasterInfo('Email invalide');
            return;
        }

        if (this.isEmailAddMode) {
            this.client.emails.push({ email });
        } else if (this.isEmailEditMode) {
            this.client.emails[this.emailToEdit.index].email = email;
        } else {
            this.client.emails = this.client.emails.filter((_, i) => i !== this.emailToEdit.index);
        }

        this.updateClient(this.client.telephones, this.client.emails, this.client.adresses).subscribe({
            next: () => {
               // this.toasterInfo(this.isEmailAddMode ? 'Ajouté' : this.isEmailEditMode ? 'Modifié' : 'Supprimé');
                this.closeEmailModal();
            },
            error: () => this.closeEmailModal()
        });
    }

    closeEmailModal() {
        if (this.modalRef) this.modalRef.close();
        this.isEmailAddMode = this.isEmailEditMode = false;
        this.emailToEdit = { email: '' };
        this.refreshFeatherIcons();
    }
}
